﻿import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { DEFAULT_TAB_CONTEXT, TabsContext } from 'components/Tabs';
import { PartnerDetails, PartnerTypes } from 'apis/PartnerApi';
import type { PartnerPermissions } from 'pages/partners/types';
import { Language } from 'apis/LanguagesApi';
import { Country } from 'apis/CountryApi';
import { State } from 'apis/StateApi';
import { User } from 'apis/UsersApi';

export interface PartnerData {
	originalPartnerDetails?: PartnerDetails;
	partnerDetails?: PartnerDetails;
	userDetails?: User;
	userDetailsOriginal?: User;
}

interface PartnersDefaultContext {
	countries: Country[];
	languages: Language[];
	partner: { name: string; type: PartnerTypes | null };
    permissions: PartnerPermissions;
    setStates: Dispatch<SetStateAction<State[]>>;
    states: State[];
}

export const PartnerDetailsContext = createContext<TabsContext<PartnerData>>(DEFAULT_TAB_CONTEXT);

export const PartnersDefaultContext = createContext<PartnersDefaultContext>({
    countries: [],
    languages: [],
    partner: { name: '', type: 1 },
    permissions: {
        AdvancedEdit: false,
        Authenticate: false,
        Create: false,
        Edit: false,
        GroupFeatureFlag: false,
        MergePartner: false,
        OrderManagementFeatureFlag: false,
        PlaceAnOrder: false,
        UserEdit: false,
        UserView: false,
        View: false
    },
    setStates: () => undefined,
    states: []
});

export const usePartners = () => useContext(PartnersDefaultContext);
